/* eslint-disable react/jsx-no-undef */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import dayjs from "dayjs";
import SecondaryButton from "../../components/button/SecondaryButton";
import { Dialog } from "@mui/material";

export default function LuckyDrawHistoryDetail() {

    const [openImagePopup, setOpenImagePopup] = React.useState(false);
    const navigate = useNavigate();
    const { state } = useLocation();


    return (
        <>

            <Dialog open={openImagePopup} fullWidth={true}>
                <button onClick={() => setOpenImagePopup(false)} className="w-[30px] border-black  border-[1px] rounded-full my-[5px] mr-[5px] ml-auto" > X </button>
                <div className="rounded-[4px] bg-black">
                    <img src={state.billPicture} alt="bill" className="w-full" onClick={() => setOpenImagePopup(true)} />
                </div >
            </Dialog >
            <TopLogo />

            <div
                style={{
                    background: "#005AAA",
                    minHeight: "calc(100vh - 60px)",
                    paddingTop: "20px"
                }}
            >

                <div className="text-white text-center text-[34px] mb-[15px]">
                    รายละเอียด
                </div>

                <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 250px)" }}>
                    <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">

                        <div className="text-center">
                            <p className="text-darkGray text-[20px]">{state.campaignName}</p>
                            <p className="text-darkGray text-[16px]">ยื่นเมื่อวันที่ {dayjs(state.createDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>

                            {state.finalApprove === 'SUCCESS' ? (
                                <div className="bg-green text-center rounded-[20px] h-[20px] w-[110px] mx-auto">
                                    <p className="text-[14px] px-[16px]">ผ่านการตรวจสอบ</p>
                                </div>
                            ) : state.finalApprove === 'FAIL' ? (
                                <div className="bg-lightRed text-center rounded-[20px] h-[20px] w-[110px] mx-auto">
                                    <p className="text-[14px] px-[8px]">ไม่ผ่านการตรวจสอบ</p>
                                </div>
                            ) : (
                                <div className="bg-yellow text-center rounded-[20px] h-[20px] w-[110px] mx-auto">
                                    <p className="text-[14px] px-[8px]">กำลังตรวจสอบ</p>
                                </div>
                            )}
                        </div>

                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[15px]" />

                        <div className="flex justify-between">
                            <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px]">ช่องทางที่ซื้อ</p>
                            <p className="text-lightBlue2 text-[16px] leading-[19.2px] px-[16px]">{state.buyFrom}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px]">ชื่อร้านค้า</p>
                            <p className="text-lightBlue2 text-[16px] leading-[19.2px] px-[16px]">{state.shopName}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px]">วันที่ออกใบเสร็จ</p>
                            <p className="text-lightBlue2 text-[16px] leading-[19.2px] px-[16px]">{dayjs(state.billDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px]">หมายเลขคำสั่งซื้อ</p>
                            <p className="text-lightBlue2 text-[16px] leading-[19.2px] px-[16px]">{state.billNo}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px]">จำนวนสิทธิ์ที่ได้รับ</p>
                            <p className="text-lightBlue2 text-[16px] leading-[19.2px] px-[16px]">{state.totalPoints}</p>
                        </div>

                        <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px] mt-[15px]">สินค้า</p>
                        {Array.isArray(state.productList
                        ) && state.productList
                            .map(item => (
                                <div className="">
                                    <div className="flex justify-between gap-[5%]">
                                        <p className="text-lightBlue2 font-bold text-[16px] leading-[19.2px] pl-[16px] w-[60%]">{item.name}</p>
                                        <p className="text-lightBlue2 font-bold text-[16px] leading-[19.2px] pr-[16px] text-right w-[35%]">{item.code}</p>
                                    </div>

                                </div>
                            ))}

                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                        <p className="text-darkGray text-[16px] leading-[19.2px] px-[16px] mt-[15px] mb-[5px]">รูปใบเสร็จ</p>


                        <img src={state.billPicture} alt="bill" className="w-full px-[16px]" onClick={() => setOpenImagePopup(true)} />

                        <br></br>
                    </div>

                </div>
            </div>
            <div className="bg-white w-full" style={{
                position: 'fixed',
                bottom: 0,
                padding: '20px'
            }}>
                <div className="place-content-center">
                    <SecondaryButton
                        fullWidth
                        variant="outlined"
                        onClick={() => navigate(-1)}
                    >
                        <p>ย้อนกลับ</p>
                    </SecondaryButton>
                </div>

            </div>
        </>
    );
}
